



import React, { useState, useEffect } from 'react';
import { getIcons } from '../Constant/Constant';

const ReAssignOption = ({ title, teamList = [], selectedId, onSelectTeam }) => {
    const icons = getIcons();
    const [selected, setSelected] = useState(selectedId);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredTeams, setFilteredTeams] = useState(teamList);

    useEffect(() => {
        setSelected(selectedId);
    }, [selectedId]);

    useEffect(() => {
        const filtered = teamList.filter(item =>
            item.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredTeams(filtered);
    }, [searchTerm, teamList]);

    const handleSelect = (id) => {
        setSelected(id);
        if (onSelectTeam) {
            onSelectTeam(id);
        }
    };

    return (
        <div className='w-6/12 border border-gray-400 rounded-xl p-4 max-h-96 flex-col flex gap-4'>
            <h1 className='font-semibold text-xl'>{title}</h1>

            <div className='relative flex bg-gray-100 rounded-md h-10 gap-3 px-5'>
                <img src={icons.searchIcon} alt="" className='w-5' />
                <input
                    type="search"
                    className='focus:outline-none bg-transparent w-full'
                    placeholder='Search'
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>

            <form>
                <div className='w-full rounded-md shadow-md h-64 overflow-auto flex flex-col gap-3 p-3'>
                    {filteredTeams.length > 0 ? (
                        filteredTeams.map((item) => (
                            <label
                                key={item.teamId || item.id}
                                htmlFor={item.teamId || item.id}
                                className={`cursor-pointer w-full flex items-center rounded-md h-10 px-3 border border-gray-100 shadow-sm gap-4 ${
                                    selected === (item.teamId || item.id) ? "bg-blue-100" : ""
                                }`}
                                onClick={() => handleSelect(item.teamId || item.id)}
                            >
                                <input
                                    type="radio"
                                    name="team"
                                    id={item.teamId || item.id}
                                    className="hidden"
                                    checked={selected === (item.teamId || item.id)}
                                    readOnly
                                />
                                <span className="w-5 h-5 border border-gray-400 rounded-full flex items-center justify-center">
                                    <div className={`w-3 h-3 bg-blue-500 rounded-full transition-opacity ${
                                        selected === (item.teamId || item.id) ? "opacity-100" : "opacity-0"
                                    }`}></div>
                                </span>
                                <span>{item.name}</span>
                            </label>
                        ))
                    ) : (
                        <p className="text-gray-500 text-center">No matching results</p>
                    )}
                </div>
            </form>
        </div>
    );
};

export default ReAssignOption;
